<template>
    <div>
        <TableVisualizationLayout :leftAction="leftAction" :showTable="false">
        <template slot="headerContent">
            <div class="row w-100">
                <div class="col-12 col-md-4">
                    <MenuFilter
                        @selecionar-categoria="categoriaSelecionada = $event"
                        @selecionar-ordenacao="ordenacaoSelecionada = $event"
                        @aplicar-filtros="filtrosSelecionados = $event"
                        @buscar-termo="termoBusca = $event"
                    />

                    <div class="mt-5" v-if="paginaAtual === 1 && artigosDestaque.length">
                        <div class="text-title">
                            Artigos
                        </div>

                        <ArticleCard
                            v-for="artigo in artigosDestaque"
                            :key="artigo.id"
                            :titulo="artigo.title"
                            :texto="artigo.coverCallout"
                            :autor="artigo.authorName"
                            :especialidade="artigo.authorSpecialty"
                            :foto-autor="artigo.authorImageUrl"
                            @click.native="abrirConteudo(artigo.id)"
                        />
                    </div>
                     <div class="mt-5" v-if="paginaAtual === 1 && comunicadosDestaque.length">
                        <div class="text-title">
                            Comunicados
                        </div>
                        <CommuniqueCard
                            v-for="comunicado in comunicadosDestaque"
                            :key="comunicado.id"
                            :titulo="comunicado.title"
                            :texto="comunicado.coverCallout"
                            @click.native="abrirConteudo(comunicado.id)"
                        />
                    </div>
                </div>
                <div class="col-12 col-md-8">
                    <Content
                        :categoria-selecionada="categoriaSelecionada"
                        :ordenacao-selecionada="ordenacaoSelecionada"
                        :filtros="filtrosSelecionados"
                        :termo-busca="termoBusca"
                        @mudar-pagina="paginaAtual = $event"
                    />
                </div>
            </div>
        </template>

            
        </TableVisualizationLayout>
       
        <Footer></Footer>        
    </div>

</template>

<script>
import TableVisualizationLayout from '../../../layouts/TableVisualizationLayout.vue';
import MenuFilter from '../components/MenuFilter.vue';
import RoutesPaths from '../../../router/router-structure/routes-paths';
import Footer from '../../../layouts/Footer.vue';
import Content from '../components/Content.vue';
import { getHighlights } from '../../../services/connection/ConnectionService.js';
import ArticleCard from '../components/ArticleCard.vue';
import CommuniqueCard from '../components/CommuniqueCard.vue';

export default {
    components: {
        TableVisualizationLayout,
        MenuFilter,
        Footer,
        Content,
        ArticleCard,
        CommuniqueCard
    },
    data() {
        return {
            categoriaSelecionada: null,
            ordenacaoSelecionada: 1,
            filtrosSelecionados: null,
            termoBusca: null,
            artigosDestaque: [],
            comunicadosDestaque: [],
            paginaAtual: 1,
            leftAction: {
                text: "Conexão cooperado",                
                onClick: this.leftActionClickHandler,
            },
        }
    },
    mounted() {
        this.scrollToTop();
        this.buscarDestaques();
    },
    methods: {
        async buscarDestaques() {
            this.carregandoDestaques = true;
            try {
                const params = {
                    category: this.categoriaSelecionada,
                    search: this.termoBusca,
                    period: this.filtrosSelecionados?.periodo,
                    initialDate: this.filtrosSelecionados?.dataInicio,
                    finalDate: this.filtrosSelecionados?.dataFim,
                };

                const resp = await getHighlights(params);

                this.artigosDestaque = resp?.articles;
                this.comunicadosDestaque = resp?.communiques;
            } catch (error) {
                console.error("Erro ao carregar destaques:", error);
                this.artigosDestaque = [];
                this.comunicadosDestaque = [];
            } finally {
                this.carregandoDestaques = false;
            }
        },
        abrirConteudo(id) {            
            this.$router.push({ path: `/conexao/visualizacao/${id}` });
        },
        scrollToTop() {
            // 1. Tenta resetar o scroll da janela (boa prática manter)
            window.scrollTo(0, 0);

            // 2. Busca o elemento real que está com o scroll
            this.$nextTick(() => {
                const container = document.querySelector('.app-background');
                if (container) {
                    container.scrollTop = 0;
                }
            });
        },
        leftActionClickHandler() {
            this.$router.push({
                path: RoutesPaths.home.rootName(),
                replace: true,
            });
        },
    }

}


</script>

<style>

.app-content-background {
    background-image: none !important;
}

.row.w-100 {
    margin-right: 0 !important;
    margin-left: 0 !important;
    overflow-x: hidden; /* Evita que o carrossel "empurre" a tela toda */
}

.text-title { 
    font-size: 20px; 
    color: #212529; 
    font-family: "Trebuchet MS", sans-serif;
}

</style>